import './_quick-shop-product-images.scss';
import component from './quick-shop-product-images';

export default component;
